module.exports = __webpack_public_path__ + "img/portfolio-11-481x325.835ba1ae.jpg";